module.exports = __webpack_public_path__ + "img/insights-report-background.ae8cbc42.png";